import useIsLoggedIn from '@@/hooks/useIsLoggedIn';
import { useRenttrack } from '@@/hooks/useRenttrack';
import { TConfig } from '@@/interfaces';
import { useConfig } from '@@/services/useConfig';

export type TNavLinkWLConfigOptions = {
  isLoggedIn: boolean;
} & ReturnType<typeof useRenttrack>;

const hasLinksToRender = (
  links: ReturnType<TConfig['navBarConfig']['getLinks']>
) =>
  Boolean(
    links?.loginLogout ||
      links?.main.length ||
      links?.footer.length ||
      links?.shouldHidePhoneLink === false ||
      links?.shouldHideSocialLinks === false
  );

export function useNavLinks() {
  const isLoggedIn = useIsLoggedIn();
  const renttrackState = useRenttrack();
  const {
    config: {
      navBarConfig: { getLinks },
    },
  } = useConfig();

  const links = getLinks({ isLoggedIn, ...renttrackState });

  return hasLinksToRender(links) ? links : null;
}
